import { useMemo } from 'react';
import { DiscoveryBlock, PageTypeEnum } from '../types';
import { findBlockByType } from '../helpers';
import { usePersonalizeBlocks } from './useDiscovery';

export const useHomePage = (serverBlocks: DiscoveryBlock[]) => {
  const { result: personalizedHomePage } = usePersonalizeBlocks({
    pageTypeEnum: PageTypeEnum.HOME,
  });

  const blocks = useMemo<DiscoveryBlock[]>(() => {
    if (personalizedHomePage?.length) {
      return personalizedHomePage;
    }
    return serverBlocks;
  }, [personalizedHomePage]);

  const slideBanners = useMemo(() => {
    const banner = findBlockByType('WIDE_THICK_BANNER', blocks);
    if (banner) {
      return banner?.cookedData || [];
    }
    return [];
  }, [blocks]);

  const topRightBanners = useMemo(() => {
    const banner = findBlockByType('VERTICAL_2_BANNER', blocks);
    if (banner) {
      return banner?.cookedData || [];
    }
    return [];
  }, [blocks]);

  const popupBanner = useMemo(() => {
    return findBlockByType('POPUP_BANNER', blocks);
  }, [blocks]);

  const horizontalFourBanners = useMemo(() => {
    return findBlockByType('HORIZONTAL_4_BANNER', blocks)?.cookedData || [];
  }, [blocks]);

  return {
    slideBanners,
    topRightBanners,
    blocks,
    popupBanner,
    horizontalFourBanners,
  };
};

export const useMobileDefaultHomePage = (serverBlocks: DiscoveryBlock[]) => {
  const { result: personalizedHomePage, isLoading: loadingHomePage } =
    usePersonalizeBlocks({ pageTypeEnum: PageTypeEnum.HOME });
  const blocks = personalizedHomePage?.length
    ? personalizedHomePage
    : serverBlocks;
  const loading = !serverBlocks && loadingHomePage;

  return {
    blocks,
    loading,
  };
};
